@let fileState = fileStateSg();
@let file = fileSg();
@let replaceExistingData = replaceExistingDataSg();
<atn-ds-widget
  class="atn-upload-data-dialog"
  title="Upload Data"
>
  <div actions>
    <i
      class="atn-icon atn-close atn-red"
      (click)="cancel.emit()"
    ></i>
  </div>
  <div class="atn-upload-data-dialog__content">
    @if (fileState === 'idle') {
      <atn-ds-file
        [types]="['.xlsx']"
        (fileChange)="fileChangeHandler($event)"
      />
    } @else {
      <div class="atn-upload-data-dialog__loader-wrapper">
        <div class="atn-upload-data-dialog__loader"></div>
      </div>
    }
  </div>
  <div
    footer
    class="atn-upload-data-dialog__footer"
  >
    <atn-ds-checkbox
      label="Remove existing data before upload"
      [selected]="replaceExistingData"
      (selectedChange)="replaceExistingDataChangeHandler($event)"
    />

    <div class="atn-upload-data-dialog__footer-buttons">
      <atn-ds-button
        style="transparent"
        (click)="cancel.emit()"
        >Cancel</atn-ds-button
      >
      <atn-ds-button
        data-test-id="confirmUploadButton"
        (click)="uploadButtonClickHandler()"
        [disabled]="!file"
        >Upload</atn-ds-button
      >
    </div>
  </div>
</atn-ds-widget>
